import React, { useState } from "react";
import "./MobileNavMenu.css";
import logo from "../../Images/earth-beauty-you-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faMagnifyingGlass, faUser } from "@fortawesome/free-solid-svg-icons";
import Cart from "../Cart/Cart";
import { Link } from "react-router-dom";
import PopCart from "../PopCart/PopCart";
import MobileSearch from "../MobileSearch/MobileSearch";
import MobileCategory from "../MobileCategory/MobileCategory";

const MobileNavMenu = ({ popCart, handlePopCart }) => {
  const [userLogin, setUserLogin] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const otpUser = JSON.parse(localStorage.getItem("user"));
  const [menu, setMenu] = useState(false);

  const handleSearch = (search) => {
    setShowSearch(search);
  };

  const handleMenu = (menu) => {
    setMenu(menu);
    setShowSearch(false);
    if (menu) {
      handlePopCart(false);
    }
  };

  // ✅ Prevent scrolling on overlays for better UX
  if (popCart || userLogin || showSearch || menu) {
    if (window.innerWidth < 640) {
      document.body.style.overflow = "hidden";
    }
  } else {
    document.body.style.overflow = "visible";
  }

  return (
    <div
      className={`mobile-menu-container ${
        showSearch ? "searched-nav-menu" : ""
      }`}
    >
      {/* ✅ Pop-up Cart */}
      <PopCart handlePopCart={handlePopCart} popCart={popCart} />

      {/* ✅ Mobile top bar with menu & search */}
      <div className="flex">
        {/* ✅ Hamburger menu with ARIA label */}
        <button
          aria-label="Open mobile menu"
          title="Open Categories Menu"
          onClick={() => handleMenu(true)}
        >
          <FontAwesomeIcon
            className="text-secondary mr-8 text-xl"
            icon={faBars}
          />
        </button>

        {/* ✅ Mobile Categories Navigation */}
        <MobileCategory menu={menu} handleMenu={handleMenu} />

        {/* ✅ Mobile search icon */}
        <button
          aria-label="Search Products"
          title="Search Earth Beauty & You products"
          onClick={() => handleSearch(!showSearch)}
        >
          <FontAwesomeIcon
            className="text-secondary text-xl"
            icon={faMagnifyingGlass}
          />
        </button>

        {/* ✅ Mobile Search Drawer */}
        <MobileSearch
          showSearch={showSearch}
          handleSearch={handleSearch}
        />
      </div>

      {/* ✅ Logo with alt, title, lazy loading */}
      <Link to="/" aria-label="Earth Beauty & You Homepage">
        <img
          className="w-[50%] mx-auto px-4"
          src="https://i.ibb.co.com/rRSmvGw5/ebay-logo.jpg"
          alt="Earth Beauty & You Logo – Organic Skincare & Haircare"
          width={334}
          height={201}
          title="Earth Beauty & You - Natural Skin & Hair Care"
          loading="lazy"
        />
      </Link>

      {/* ✅ User Account Icon */}
      {otpUser?.phone ? (
        <Link
          to="/dashboard"
          aria-label="Go to My Account"
          title="My Account"
          className="ml-auto"
        >
          <FontAwesomeIcon
            className="text-secondary text-2xl absolute right-16 bottom-[26px]"
            icon={faUser}
          />
        </Link>
      ) : (
        <Link
          to="/customerDashboard"
          aria-label="Login or Register"
          title="Login / Register"
          className="ml-auto"
        >
          <FontAwesomeIcon
            className="text-secondary text-2xl absolute right-16 bottom-[26px]"
            icon={faUser}
          />
        </Link>
      )}

      {/* ✅ Cart Icon */}
      <div className="ml-auto">
        <Cart
          popCart={popCart}
          handlePopCart={handlePopCart}
          handleSearch={handleSearch}
        />
      </div>

      {/* ✅ Overlay for search/menu/cart */}
      <span
        className={`overlay ${
          showSearch ? "searched-overlay" : "not-searched-overlay"
        } ${userLogin ? "overlay-active" : ""} ${
          popCart || menu ? "overlay-active" : ""
        }`}
      ></span>
    </div>
  );
};

export default MobileNavMenu;
